import React, { useEffect } from "react";
import Nav from "./components/Nav";
import Hagz from "./components/7agz";
import Ask from "./components/Ask";
import Footer from "./components/Footer";
import FloatingIcons from "./components/FloatingIcons";

const Book = () => {
  return (
    <>
      <Nav />
      <FloatingIcons />
      <div style={{ paddingTop: "50px" }}>
        <Hagz />
      </div>
      <Ask />
      <Footer />
    </>
  );
};

export default Book;
